module.exports = __webpack_public_path__ + "static/media/emojis2_26.dbc027bf.svg";